import React, { useState, useEffect } from 'react';
import { superAdminAPI } from '../services/api';


function SuperAdminAnalytics({ companies = [] }) {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    fetchAnalytics();
  }, [selectedCompanyId]);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const params = {};
      if (selectedCompanyId) {
        params.company_id = selectedCompanyId;
      }
      
      const response = await superAdminAPI.getAnalytics(params);
      setAnalytics(response.data);
      setError('');
    } catch (err) {
      console.error('Failed to load analytics:', err);
      setError(err.response?.data?.error || 'Failed to load analytics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading analytics...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  if (!analytics) {
    return <div>No analytics data available</div>;
  }

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2>Analytics Overview</h2>
        <div style={{marginTop: '10px'}}>
          <select
            value={selectedCompanyId || ''}
            onChange={(e) => setSelectedCompanyId(e.target.value ? parseInt(e.target.value) : null)}
            style={{padding: '5px'}}
          >
            <option value="">All Companies</option>
            {companies.map(company => (
              <option key={company.id} value={company.id}>{company.name}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Summary Cards */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px'}}>
        <div className="card">
          <h3>Companies</h3>
          <div style={{fontSize: '32px', fontWeight: 'bold', color: '#007bff'}}>
            {analytics.summary?.total_companies || 0}
          </div>
          <div style={{color: 'var(--color-gray)', fontSize: '14px'}}>
            {analytics.summary?.active_companies || 0} active
          </div>
        </div>
        
        <div className="card">
          <h3>Users</h3>
          <div style={{fontSize: '32px', fontWeight: 'bold', color: '#28a745'}}>
            {analytics.summary?.total_users || 0}
          </div>
          <div style={{color: 'var(--color-gray)', fontSize: '14px'}}>
            {analytics.summary?.active_users || 0} active
          </div>
        </div>
        
        <div className="card">
          <h3>Bikes</h3>
          <div style={{fontSize: '32px', fontWeight: 'bold', color: '#ffc107'}}>
            {analytics.summary?.total_bikes || 0}
          </div>
        </div>
        
        <div className="card">
          <h3>Services</h3>
          <div style={{fontSize: '32px', fontWeight: 'bold', color: '#17a2b8'}}>
            {analytics.summary?.total_services || 0}
          </div>
        </div>
        
        <div className="card">
          <h3>Bookings</h3>
          <div style={{fontSize: '32px', fontWeight: 'bold', color: '#6f42c1'}}>
            {analytics.summary?.total_bookings || 0}
          </div>
        </div>
      </div>

      {/* Services by Company */}
      {analytics.services_by_company && analytics.services_by_company.length > 0 && (
        <div className="card" style={{marginBottom: '20px'}}>
          <h3>Services by Company</h3>
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Services Count</th>
                  <th>Total Revenue</th>
                </tr>
              </thead>
              <tbody>
                {analytics.services_by_company.map((item, index) => (
                  <tr key={index}>
                    <td>{item.company_name}</td>
                    <td>{item.count}</td>
                    <td>£{parseFloat(item.total_cost || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Bookings by Status */}
      {analytics.bookings_by_status && analytics.bookings_by_status.length > 0 && (
        <div className="card">
          <h3>Bookings by Status</h3>
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {analytics.bookings_by_status.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <span className={`badge ${
                        item.status === 'completed' ? 'badge-success' :
                        item.status === 'confirmed' ? 'badge-info' :
                        item.status === 'in_progress' ? 'badge-warning' :
                        item.status === 'cancelled' ? 'badge-danger' :
                        'badge-secondary'
                      }`}>
                        {item.status}
                      </span>
                    </td>
                    <td>{item.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuperAdminAnalytics;










